<template>
    <v-flex class="white_background">
        <v-container class="assistPage">
            <h2>{{WelcomeConstants.WELCOME_HEADER}}
                <v-btn
                    class="primary_btn"
                    data-qe-id="share_feedback_btn"
                    @click="showFeedbackDailog">
                    {{WelcomeConstants.SHARE_FEEDBACK}}
                </v-btn>
            </h2>
            <take-a-tour></take-a-tour>

            <ReleaseNotesView></ReleaseNotesView>

        </v-container>

        <v-dialog
            scrollable
            v-model="feedbackDialog.dialogOpen"
            content-class="small"
            persistent>
            <FeedbackForm :close-feed-back-dialog="closeFeedBackDialog" :main-dialog="feedbackDialog.dialogOpen"></FeedbackForm>
        </v-dialog>
    </v-flex>
</template>

<script>
    import { WelcomeConstants } from "../AssistPage/AssistPageConstants";
    import ReleaseNotesView from "../AssistPage/ReleaseNotes";
    import TakeATour from "../AssistPage/TakeATour";
    import FeedbackForm from "./Feedback.vue";

    export default {
        name: "AssistPage",
        components: {
            ReleaseNotesView,
            TakeATour,
            FeedbackForm,
        },
        data: () => ({
            WelcomeConstants,
            feedbackDialog: {
                dialogOpen: false,
            },
            mainDialogOpen: { dialogOpen: false },

        }),
        methods: {
            showFeedbackDailog() {
                this.feedbackDialog.dialogOpen = true;
                this.mainDialogOpen.dialogOpen = true;
            },
            closeFeedBackDialog() {
                this.feedbackDialog.dialogOpen = false;
                this.mainDialogOpen.dialogOpen = true;
            },
        },
    };
</script>

<style lang="scss">
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/responsive.scss";

    .assistPage {
        margin-top: 64px;

        h2,
        h3,
        .v-expansion-panel__body,
        .v-expansion-panel__header {
            font-family: "Raleway", sans-serif;
        }

        h2 {
            color: $ypo-blue;
            margin: 0px 0 40px 0;
            padding: 30px 0 10px 0;
            border-bottom: 1px solid $ypo-blue;
            font-weight: 400;
            font-size: 24px;
            position: relative;

            .v-btn {
                position: absolute;
                right: 0;
                bottom: 10px;
                margin: 0;
            }
        }

        h3 {
            font-size: 22px;
            color: $ypo-blue;
            font-weight: 500;
            margin: 10px 0;
        }

        @include breakpoint(xs) {
            padding-bottom: 100px !important;

            h2 {
                font-size: 18px;
                padding: 10px;

                .v-btn {
                    right: 10px;
                    padding: 8px 15px;
                }
            }

            h3 {
                padding: 0 10px;
                font-size: 16px;
            }
        }

    }

    @include breakpoint(sm) {
        .header {
            &.in {
                &+.flex {
                    .assistPage {
                        padding-top: 30px;
                    }
                }

            }
        }
    }
    .cke_panel {
        z-index: 99 !important;
        .cke_panel_frame {
           min-height: 45px;
        }
    }
</style>
